module.exports = __webpack_public_path__ + "img/icon-help.50a99bfd.svg";